import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Box } from '@rebass/grid';
import { isMobile } from 'app/helpers/utils';

const ORANGE = '#F49F61';
const GRAY = '#F8F8F8';

const Step = styled(({ complete, current, inactive, width, children, ...rest }) => (
  <Box {...rest}>{children}</Box>
))`
  opacity: ${({ inactive }) => (inactive ? 0 : 1)};
  padding-top: ${isMobile ? '0px' : '2px'};
  transition: ease 0.25s;
  position: relative;
  font-size: ${({ size }) => size}px;
  width: ${({ width }) => width * 100}%;
  color: ${({ complete, current }) => (complete || current ? '#646464' : GRAY)};
  font-weight: 500;
  &:before {
    transition: ease 0.25s;
    border-radius: 50%;
    height: 20px;
    width: 20px;
    background: ${({ complete, current }) =>
      current ? 'white' : complete ? ORANGE : GRAY};
    border: 2.5px solid;
    border-color: ${({ complete, current }) =>
      complete || current ? ORANGE : GRAY};
    position: absolute;
    top: -20px;
    left: 0;
    right: 0;
    margin: auto;
    z-index: 2;
    line-height: 16px;
    color: white;
    // font awesome
    font-family: 'Font Awesome 5 Free';
    font-weight: 900;
    ${({ complete }) => (complete ? `content:'\f00c'` : `content:'';`)};
  }
  &:not(:first-of-type):after {
    transition: ease 0.25s;
    content: '';
    position: absolute;
    top: -10px;
    left: -50%;
    right: 50%;
    margin: auto;
    height: 2.5px;
    width: 100%;
    background: ${({ complete, current }) =>
      complete || current ? ORANGE : GRAY};
    z-index: 1;
  }
`;

Step.propTypes = {
  complete: PropTypes.bool.isRequired,
  current: PropTypes.bool.isRequired,
  inactive: PropTypes.bool.isRequired,
  size: PropTypes.number.isRequired,
};

Step.defaultProps = {
  complete: false,
  current: false,
  inactive: true,
  size: isMobile ? 13 : 11,
};

export default Step;
